import { PREFERENCE_EXPIRATION_YEAR, EU_CONSENT_PREFERENCES_COOKIE, DEFAULT_CONSENT_PREFERENCES_COOKIE } from '../constants.js';
import { getDomainWithoutSubdomain } from './getDomain.js';
const setTrackingPreference = (setCookie, newConsentPreference, region, onPreferenceChange) => {
  const expiration = PREFERENCE_EXPIRATION_YEAR * 365;
  const cookieOptions = {
    expires: expiration,
    domain: getDomainWithoutSubdomain(),
    path: '/'
  };
  if (region === 'EU') {
    setCookie(EU_CONSENT_PREFERENCES_COOKIE, newConsentPreference, cookieOptions);
  } else {
    setCookie(DEFAULT_CONSENT_PREFERENCES_COOKIE, newConsentPreference, cookieOptions);
  }
  if (onPreferenceChange) {
    onPreferenceChange(newConsentPreference);
  }
};
export { setTrackingPreference as default };
//# sourceMappingURL=setTrackingPreference.js.map
